import { MapPin } from "lucide-react";
import { DELEGACIONES, nombreDelegacion } from "./delegaciones";
import "./dashboard.scss";

/**
 * Selector de delegación de los widgets operativos del dashboard
 * ("Cuadrantes sin cubrir", "Trabajadores sin turnos", "Subactividad").
 * Filtrado client-side: las descargas no cambian, solo lo que se pinta.
 */
const DelegacionFilter = ({ value, onChange, opciones }) => (
  <label className="delegacion-filter">
    <MapPin size={16} />
    <span>Delegación</span>
    <select value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">Todas</option>
      {opciones.map((cod) => (
        <option key={cod} value={cod}>
          {DELEGACIONES[cod] ? `${cod} — ${DELEGACIONES[cod]}` : nombreDelegacion(cod)}
        </option>
      ))}
    </select>
  </label>
);

export default DelegacionFilter;
